import { render, staticRenderFns } from "./ForgotPassword-v2.vue?vue&type=template&id=8ca7dbe8&"
import script from "./ForgotPassword-v2.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword-v2.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports